import { getEsim, postActiveESim } from "../api/esimApi";
import { ActiveESimResponse } from "../types/esim";

export interface EsimCollectionModel {
  active: EsimModel[];
  expired: EsimModel[];
}
export interface EsimModel {
  msisdn: string;
  purchaseDate: string;
  status: string;
  packageName: string;
  esimQrCode: string;
  activeStop: string;
}

export const fetchEsimCollection = async (
  cusId: string
): Promise<EsimCollectionModel> => {
  const res = await getEsim(cusId);
  const esimCollection = res.data;
  return {
    active: esimCollection.active.map((esimInfo) => ({
      msisdn: esimInfo.msisdn,
      purchaseDate: esimInfo.created_at,
      status: esimInfo.status_sim,
      packageName: esimInfo.package_name,
      esimQrCode: esimInfo.img,
      activeStop: esimInfo.active_stop,
    })),

    expired: esimCollection.expired.map((esimInfo) => ({
      msisdn: esimInfo.msisdn,
      purchaseDate: esimInfo.created_at,
      status: esimInfo.status_sim,
      packageName: esimInfo.package_name,
      esimQrCode: esimInfo.img,
      activeStop: esimInfo.active_stop,
    })),
  };
};

export const activeESim = async (
  msisdn: string
): Promise<ActiveESimResponse> => {
  const res = await postActiveESim(msisdn);
  return res;
};
